/**
 * Helpers for the donation "Other" amount field.
 * Uses text + digits-only parsing so mobile keyboards behave consistently.
 */

export function sanitizeCustomAmountInput(raw) {
  if (raw == null) return ''
  const trimmed = String(raw).trim()
  // Pasted currency like "$100.00" should become 100, not 10000.
  const currencyMatch = trimmed.match(/^\$?\s*(\d{1,5})(?:\.\d{0,2})?$/)
  if (currencyMatch) return currencyMatch[1]
  return trimmed.replace(/\D/g, '').slice(0, 5)
}

export function parseCustomAmountNumber(raw) {
  const sanitized = sanitizeCustomAmountInput(raw)
  if (!sanitized) return NaN
  const n = Number(sanitized)
  return Number.isFinite(n) ? n : NaN
}

/** When the user exceeds five digits, drop the last digit typed. */
export function clampCustomAmountDigits(raw) {
  const sanitized = sanitizeCustomAmountInput(raw)
  if (sanitized.length <= 5) return sanitized
  return sanitized.slice(0, 5)
}

export function resolveDonationAmount({ customAmount, donationAmount, defaultAmount }) {
  const custom = sanitizeCustomAmountInput(customAmount)
  if (custom) return Number(custom)
  if (donationAmount != null && donationAmount !== '') return Number(donationAmount)
  if (defaultAmount != null && defaultAmount !== '') return Number(defaultAmount)
  return 0
}

export function sortedSuggestedAmounts(amounts = []) {
  return [...amounts].sort((a, b) => b - a)
}
